import React, { PropTypes } from 'react';
import { FlatButton, Dialog } from 'material-ui';
import { connect } from 'react-redux';
import CheckYourProgress from './check-your-progress/main';
const DraftCompletionErrors = ({ open, errors, onRequestClose, productsMap }) => {
  return (
    <Dialog
      open={open}
      autoScrollBodyContent
      actions={<FlatButton
        label={!productsMap ? 'DISMISS' : 'Continue Editing'}
        labelStyle={{ fontWeight: '600' }}
        secondary
        onTouchTap={onRequestClose}
      />}
      title={<div style={{ backgroundColor: '#00BCD4', color: 'white', fontSize: '18px', padding: '2%' }} >
        What's missing?
      </div>}
    >
      <CheckYourProgress errors={errors} productsMap={productsMap} onRequestClose={onRequestClose} style={{ marginTop: '8px' }} />
    </Dialog>
  );
};

DraftCompletionErrors.propTypes = {
  errors: PropTypes.object,
  onRequestClose: PropTypes.func,
  productsMap: PropTypes.object,
};
const mapStateToProps = ({ contracting }) => ({
  open: contracting.contractActivitiesProducts.get('showAllDraftErrorsDialog'),
  productsMap: contracting.contractActivitiesProducts.getIn(['leftNav', 'productsArray']) ? contracting.contractActivitiesProducts.getIn(['leftNav', 'productsArray']).toJS().reduce((result, product) => {
    result[product.productId] = product.productName;
    return result;
  }, {}) : {},
  errors: contracting.contractActivitiesProducts.toJS().draftErrors,
});

export default connect(mapStateToProps)(DraftCompletionErrors);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/progressIndicatorBar/draftCompletionErrors.jsx